import { MutableRefObject, useRef, useState } from "react";
import { ExerciseMessage } from "../Utils/Message/ExerciseMessage";
import { TonicSelector } from "../../../Util/TonicSelector/TonicSelector";
import { Music } from "../../../Util/Music/Music";
import { PositionSelector } from '../../../Util/PositionSelector/PositionSelector';
import { HxChildMap } from "../../../Comps/HxMap/HxChildMap";
import { PositionButtons } from "../../../Comps/NoteButtons/PositionButtons";
import { All } from "../../../Util/Constants/Quantities";
import { OutlineBox } from "../../../Comps/OutlineBox/OutlineBox";
import { NotePlayer } from "../../../Sound/NotePlayer";
import { useNotePlayer } from "../../../Sound/SoundStore";
import { Chords } from "../../../Util/Music/Chords";

export function ChordShapeExercise(){
    const notePlayer:MutableRefObject<NotePlayer> = useRef(useNotePlayer())
    notePlayer.current.reset()
    const tonic:number = Music.C
    const positionSelector:MutableRefObject<TonicSelector> = useRef(new PositionSelector(5))
    const selectedPosition:MutableRefObject<number> = useRef(-1)
    const getAnswerNoteIndexes = (position:number) => { return[position, (position + 2) % 7, (position + 4) % 7] }
    const initialMessage:string = 'Identify the chord shape by number. Click Start to begin.'
    const [started, setStarted] = useState(false)
    const [message, setMessage] = useState(initialMessage)
    const [answerMessage, setAnswerMessage] = useState('')
    const [answerStatus, setAnswerStatus] = useState<null|boolean>(null)
    const [hilitedNotes, setHilitedNotes] = useState<number[]>([])
    const setAnswer = (answerMessage:string, correct:boolean|null) => {
        setAnswerStatus(correct)
        setAnswerMessage(answerMessage)
    }
    const onStart = () => {
        notePlayer.current.reset()
        setStarted(true)
        nextPosition()
    }
    const clearAnswerStatus = () => {
        setAnswerStatus(null)
        setAnswerMessage('')
    }
    const nextPosition = () => {
        notePlayer.current.reset()
        selectedPosition.current = positionSelector.current.getRandomPosition(selectedPosition.current)
        setHilitedNotes(getAnswerNoteIndexes(selectedPosition.current))
        setMessage(`What number chord is this?`)
        clearAnswerStatus()
    }
    const onCorrect = (indexLabel:string) => {
        const chordNotes:number[] = Chords.GetChordNoteTonics(tonic, selectedPosition.current)
        notePlayer.current.playChord(chordNotes, true)
        setAnswer(`${indexLabel} is correct!`, true)
        setTimeout(nextPosition, 1500)
    }
    const onIncorrect = (indexLabel:string) => {
        notePlayer.current.playBuzzer()
        setAnswer(`${indexLabel} is incorrect. Try again.`, false)
        setTimeout(clearAnswerStatus, 1500)
    }
    const onAnswer = (index:number) => {
        if(started){
            const label:string = String(index + 1);
            (index === selectedPosition.current) ? onCorrect(label) : onIncorrect(label)
        }
    }
    const AnswerMessage = () => {
        if(!started || answerMessage === ''){return null}
        return(
            <ExerciseMessage message={answerMessage} answerStatus={answerStatus}/>
        )
    }
    const StartButton = () => {
        if(started){return null}
        return(
            <button type='button' onClick={onStart}>Start</button>
        )
    }
    return(
        <OutlineBox title={'Chord Shape Memorizer'} width={600}>
            <div style={{position:'relative'}}>
                <ExerciseMessage answerStatus={null} message={message} forceRefresh={false}/>
                <div style={{marginTop:55, marginBottom:35, opacity:((started)?1:0.15)}}>
                    <HxChildMap tonic={tonic} radius={120}
                                        width={320}
                                        height={320} 
                                        hilitedNotes={hilitedNotes} 
                                        definedNotes={[]} 
                                        onNoteClick={()=>{}}
                                        onKeyClick={()=>{}}/>
                </div>
                
                <div>
                    <div style={{position:'absolute', top:'20px', width:'100%'}}>
                        <AnswerMessage/>
                    </div>
                    <div style={{position:'absolute', top:'230px', width:'100%', scale:1.5}}>
                        <StartButton/>
                    </div>
                </div>
                        
                <PositionButtons onClick={onAnswer}/>
            </div>
        </OutlineBox>
    )
    
}